import { Box, Typography, styled } from '@mui/material';

import { CourseDiscussionItemType } from '.';

export const DiscussionItemStyle = styled(Box)<{ type: CourseDiscussionItemType }>(({ theme, type }) => ({
  display: 'flex',
  gap: 8,
  borderBottom: type === CourseDiscussionItemType.LIST_ITEM ? '1px solid' : 'none',
  borderColor: theme.palette.divider,
  padding: type === CourseDiscussionItemType.LIST_ITEM ? '16px 0' : '0',

  '&:last-child': {
    borderBottom: 'none',
  },

  '.badge-author': {
    height: 22,
    width: 48,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.commonText?.primary,
    fontSize: 14,
    borderRadius: 20,
  },
}));

export const ContentStyle = styled(Typography)<{
  type: CourseDiscussionItemType;
  isShowAll: boolean;
  lineClamp: string;
}>(({ type, isShowAll, lineClamp }) => ({
  marginTop: 8,
  overflow: 'hidden',
  display: isShowAll || type === CourseDiscussionItemType.FULL_INFO ? 'block' : '-webkit-box',
  '-webkit-line-clamp': lineClamp,
  '-webkit-box-orient': 'vertical',
  overflowWrap: 'anywhere',
}));
